import { ref } from 'vue';
import type { WizardOptions } from '@/widgets/Wizard/models/time-table/wizard-options';
import type { TimeTableGateway } from '@/widgets/Wizard/gateways/time-table';
import type { Account } from '@/widgets/Wizard/models/accounts';

export function useTimeTableWizardOptions() {
    const activeWizardOptions = ref<WizardOptions | null>(null);
    const wizardOptionsChanged = ref(false);

    const updateWizardOptions = (options: WizardOptions | null, reload: boolean = false) => {
        if (!reload) {
            activeWizardOptions.value = options;
            return;
        }

        wizardOptionsChanged.value = false;

        if (
            (options === null && activeWizardOptions.value !== null) ||
            (options !== null && activeWizardOptions.value === null)
        ) {
            wizardOptionsChanged.value = true;
        }

        if (JSON.stringify(activeWizardOptions.value) !== JSON.stringify(options)) {
            wizardOptionsChanged.value = true;
        }

        activeWizardOptions.value = options;
    };

    const wizardOptionsChangeHandled = () => {
        wizardOptionsChanged.value = false;
    };

    return {
        activeWizardOptions,

        wizardOptionsChanged,

        updateWizardOptions,
        wizardOptionsChangeHandled,
    };
}

export async function checkTimeTableWizardOptions(
    timeTable: TimeTableGateway,
    account: Account,
): Promise<WizardOptions | null> {
    return await timeTable.getWizardOptions(account);
}
